/* Read More Show/Hide */
document.addEventListener("DOMContentLoaded", function(event) { 
  document.querySelector(".collection-hero").addEventListener('click', function(e) {      
    if( e.target.classList.contains('collection-hero__more-link') ) {
        
      const description_truncated = document.querySelector('.collection-hero__description--short');
      const description_full = document.querySelector('.collection-hero__description--full');

      if (description_truncated.style.display === "none") {
        description_truncated.style.display = "block";
        description_full.style.display = "none";
      } else {
        description_truncated.style.display = "none";
        description_full.style.display = "block";
      }

    }
  });
});